import { Role } from '@/shared/enums';

export const roleMap = new Map<number, string>([
  [Role.Sys, '系统管理员'],
  [Role.Admin, '管理员'],
  [Role.SuperUser, 'SuperUser'],
  [Role.User, '一般用户']
]);
